import React from 'react';
import Button from 'react-bootstrap/Button';
import  Modal from 'react-bootstrap/Modal';
import { Container } from 'react-bootstrap';
import { Row } from 'react-bootstrap';

export class Options extends React.Component {

  constructor(props) {
    super(props);
  
    this.state = {
      largeNumberCount: props.largeNumberCount,
      totalNumberCount: props.totalNumberCount,
    };
  }
   
  handleLargeNumberChange = (parm1) => {
    let numberCount = this.state.largeNumberCount + parm1;
    if (numberCount >= 0 && numberCount <= 4)
    this.setState({
       largeNumberCount: numberCount,
      }); 
 }

 handleTotalNumberChange = (parm1) => {
  let numberCount = this.state.totalNumberCount + parm1;
  if (numberCount >= 6 && numberCount <= 8)
  this.setState({
     totalNumberCount: numberCount,
    }); 
}

 render() {
    return (
      <div id='Options'>
        <Modal show={true} onHide={this.handleClose}>
          <Modal.Header>
            <Modal.Title>Options</Modal.Title>
          </Modal.Header>
          <Modal.Body className="show-grid">
        <Container>
          <Row>
          <div className="col-6">
            <label className='options-text'>Large numbers:</label>
            </div>
            <div className="col-6">
            <button className='optionsButton options-text' onClick={() => this.handleLargeNumberChange(-1)} >-</button>
            &nbsp;
            <input className='options-text' type="text" size="2" readOnly
                    value={this.state.largeNumberCount} />
            &nbsp;
            <button className='optionsButton options-text' onClick={() => this.handleLargeNumberChange(1)} >+</button>
            </div>
          </Row>
          <hr />
          <Row>
          <div className="col-6">
            <label className='options-text'>Total numbers:</label>
            </div>
            <div className="col-6">
            <button className='optionsButton options-text' onClick={() => this.handleTotalNumberChange(-1)} >-</button>
            &nbsp;
            <input className='options-text' type="text" size="2" readOnly
                    value={this.state.totalNumberCount} />
            &nbsp;
            <button className='optionsButton options-text' onClick={() => this.handleTotalNumberChange(1)} >+</button>
            </div>
          </Row>
          </Container>
      </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => this.props.onCloseClick()}>
              Close
            </Button>
            <Button variant="primary" onClick={() => this.props.onSaveClick(this.state.largeNumberCount, this.state.totalNumberCount)}>
              Save Changes
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
    }
}

